const constants = {
  borderRadius: '10px',
  simulationsRutes: ['settings', 'menus', 'common-menus'],
  menusRutes: ['menus', 'common-menus'],
  roles: {
    admin: 'b3be3c72-65f6-4aa5-b1f6-5c43cd9324a4',
    normal: '9fb4c0c5-ad6c-48ea-8137-cc1192c2138c'
  },
  userPermission: [
    {
      id: 1,
      name: 'logs',
      icon: 'mdi-account-clock-outline'
    },
    {
      id: 2,
      name: 'stats',
      icon: 'mdi-gesture-double-tap'
    },
    {
      id: 3,
      name: 'moveContent',
      icon: 'mdi-file-move-outline'
    },
    {
      id: 4,
      name: 'cloneMenu',
      icon: 'mdi-content-copy'
    },
    {
      id: 5,
      name: 'cloneEnterprise',
      icon: 'mdi-content-copy'
    },
    {
      id: 6,
      name: 'editDesktopMode',
      icon: 'mdi-desktop-mac-dashboard'
    },
    {
      id: 7,
      name: 'commonMenus',
      icon: 'mdi-menu'
    },
    {
      id: 8,
      name: 'productService',
      icon: 'mdi-decagram'
    },
    {
      id: 9,
      name: 'poll',
      icon: 'mdi-poll'
    },
    {
      id: 10,
      name: 'dishOrders',
      icon: 'mdi-food-variant'
    },
    {
      id: 11,
      name: 'welcomeForm',
      icon: 'mdi-form-select'
    },
  ],
  menus: [
    {
      icon: 'mdi-home',
      title: 'dashboard.title',
      rute: '/dashboard',
      admin: false
    },
    {
      icon: 'mdi-account-multiple',
      title: 'users.title',
      rute: '/users',
      admin: true
    },
    {
      icon: 'mdi-badge-account-horizontal',
      title: 'enterprises.title',
      rute: '/enterprises',
      admin: true
    },
    // {
    //   icon: 'mdi-menu',
    //   title: 'commonMenus.title',
    //   rute: '/common-menus',
    //   admin: true
    // },
  ],
  menuType: [
    {
      id: 1,
      name: 'submenu',
      icon: 'mdi-menu'
    },
    {
      id: 2,
      name: 'simpleText',
      icon: 'mdi-text-short'
    },
    {
      id: 3,
      name: 'space',
      icon: 'mdi-arrow-expand-vertical'
    },
    {
      id: 4,
      name: 'image',
      icon: 'mdi-image'
    },
    {
      id: 6,
      name: 'alert',
      icon: 'mdi-card-text'
    },
    {
      id: 7,
      name: 'gallery',
      icon: 'mdi-image-multiple'
    },
    {
      id: 8,
      name: 'video',
      icon: 'mdi-video'
    },
    {
      id: 16,
      name: 'text',
      icon: 'mdi-text-long',
      IsExclusive: false
    },
    {
      id: 5,
      name: 'iframe',
      icon: 'mdi-application-outline',
      IsExclusive: true
    },
    {
      id: 9,
      name: 'meteo',
      icon: 'mdi-weather-partly-cloudy',
      IsExclusive: true
    },
    {
      id: 10,
      name: 'map',
      icon: 'mdi-google-maps',
      IsExclusive: true
    },
    {
      id: 11,
      name: 'twitter',
      icon: 'mdi-twitter',
      IsExclusive: true
    },
    {
      id: 12,
      name: 'facebook',
      icon: 'mdi-facebook',
      IsExclusive: true
    },
    {
      id: 13,
      name: 'activities',
      icon: 'mdi-table-tennis',
      IsExclusive: true
    },
    {
      id: 14,
      name: 'pdf',
      icon: 'mdi-file-pdf-box',
      IsExclusive: true
    },
    {
      id: 15,
      name: 'timeline',
      icon: 'mdi-timeline-text',
      IsExclusive: true
    },
    {
      id: 17,
      name: 'contact',
      icon: 'mdi-card-account-phone',
      IsExclusive: true
    },
    {
      id: 18,
      name: 'divider',
      icon: 'mdi-minus',
      IsExclusive: false
    },
    {
      id: 19,
      name: 'shows',
      icon: 'mdi-ticket',
      IsExclusive: true
    },
    {
      id: 20,
      name: 'site',
      icon: 'mdi-map-marker',
      IsExclusive: true
    },
    {
      id: 21,
      name: 'agenda',
      icon: 'mdi-calendar',
      IsExclusive: true
    },
    {
      id: 22,
      name: 'parrilla',
      icon: 'mdi-filmstrip',
      IsExclusive: true
    },
    {
      id: 23,
      name: 'wifi',
      icon: 'mdi-wifi',
      IsExclusive: true
    },
    {// only century21
      id: 24,
      name: 'property',
      icon: 'mdi-home-group',
      IsExclusive: false
    },
    {// only century21
      id: 25,
      name: 'commercial',
      icon: 'mdi-account-tie',
      IsExclusive: false
    },
    {// only century21
      id: 26,
      name: 'queue',
      icon: 'mdi-sort-numeric-ascending',
      IsExclusive: false
    },
    {
      id: 27,
      name: 'food',
      icon: 'mdi-food-fork-drink',
      IsExclusive: false
    },
    {
      id: 28,
      name: 'linkDomain',
      icon: 'mdi-gesture-tap-button',
      IsExclusive: false
    },
    {
      id: 29,
      name: 'form',
      icon: 'mdi-file-document-edit',
      IsExclusive: false
    },
    {
      id: 30,
      name: 'productService',
      icon: 'mdi-decagram',
      IsExclusive: false
    },
    {
      id: 31,
      name: 'pdfTranslate',
      icon: 'mdi-file-pdf-box',
      IsExclusive: true
    },
    {
      id: 32,
      name: 'linkExternal',
      icon: 'mdi-gesture-tap-button',
      IsExclusive: false
    },
    {
      id: 33,
      name: 'channelList',
      icon: 'mdi-gesture-tap-button',
      IsExclusive: false
    },
    {
      id: 34,
      name: 'acttiv',
      icon: 'mdi-table-tennis',
      IsExclusive: true
    },
    {
      id: 35,
      name: 'poll',
      icon: 'mdi-poll',
      IsExclusive: false
    },
    {
      id: 36,
      name: 'instagram',
      icon: 'mdi-instagram',
      IsExclusive: true
    },
    {
      id: 37,
      name: 'iconList',
      icon: 'mdi-format-list-text',
      IsExclusive: true
    },
    {
      id: 38,
      name: 'dropdownButton',
      icon: 'mdi-form-dropdown',
      IsExclusive: true
    },
    {
      id: 39,
      name: 'dfiles',
      icon: 'mdi-folder',
      IsExclusive: true
    },
    {
      id: 40,
      name: 'rcovid',
      icon: 'mdi-virus',
      IsExclusive: true
    },
    {
      id: 41,
      name: 'imageTranslate',
      icon: 'mdi-message-image'
    },
    {
      id: 42,
      name: 'iberostarFood',
      icon: 'mdi-food-fork-drink',
      IsExclusive: true
    },
    {
      id: 43,
      name: 'icons',
      icon: 'mdi-image-filter-center-focus',
      IsExclusive: true
    },
    {
      id: 44,
      name: 'hsconsulting',
      icon: 'mdi-leak',
      IsExclusive: false
    },
    {
      id: 45,
      name: 'brochure',
      icon: 'mdi-map-search',
      IsExclusive: false
    },
    {
      id: 46,
      name: 'infoTen',
      icon: 'mdi-book-information-variant',
      IsExclusive: false
    },
    {
      id: 47,
      name: 'cMBooking',
      icon: 'mdi-notebook',
      dbTable: 'content_47_cmbooking',
    },
    {
      id: 48,
      name: 'cmActivities',
      icon: 'mdi-bookmark-box-multiple',
      dbTable: 'content_48_booking_activities',
    },
    {
      id: 49,
      name: 'menuExtFood',
      icon: 'mdi-food',
      dbTable: 'content_49_menu_ext_food',
    },
    {
      id: 50,
      name: 'cMAttendance',
      icon: 'mdi-bookmark-box-multiple',
      dbTable: 'content_50_attendance',
    },
    {
      id: 51,
      name: 'cmWeeklyMenu',
      icon: 'mdi-food',
      dbTable: 'content_51_weekly_menu',
    },
    {
      id: 54,
      name: 'formCio',
      icon: 'mdi-format-list-text',
      IsExclusive: true
    },
    {
      id: 55,
      name: 'dviewcontentMessages',
      icon: 'mdi-message-text-outline',
      IsExclusive: true
    },
    {
      id: 56,
      name: 'servatur',
      icon: 'mdi-code-brackets',
      IsExclusive: true
    },
    {
      id: 57,
      name: 'interactiveMaps',
      icon: 'mdi-map-marker-path',
      IsExclusive: true
    },
    {
      id: 58,
      name: 'abamaRequestReservation',
      icon: 'mdi-calendar-badge',
      IsExclusive: true
    },
    {
      id: 59,
      name: 'effilabel',
      icon: 'mdi-card-account-details',
      IsExclusive: true
    },
    {
      id: 62,
      name: 'chekin',
      icon: 'mdi-bookmark-check',
      IsExclusive: true
    },
    {
      id: 63,
      name: 'qAndA',
      icon: 'mdi-message-question',
      IsExclusive: true
    },
    /*
    {
      id: 60,
      name: 'effiwaste',
      icon: 'mdi-scale',
      IsExclusive: true
    },
    */
    {
      id: 65,
      name: 'abamaLinkRoom',
      icon: 'mdi-circle-small',
      IsExclusive: true
    },
    {
      id: 66,
      name: 'abamaRequest',
      icon: 'mdi-circle-small',
      IsExclusive: true
    },
  ],
  isoLangs: {
    'ab': {
      'name': 'Abkhaz',
      'nativeName': 'аҧсуа'
    },
    'aa': {
      'name': 'Afar',
      'nativeName': 'Afaraf'
    },
    'af': {
      'name': 'Afrikaans',
      'nativeName': 'Afrikaans'
    },
    'ak': {
      'name': 'Akan',
      'nativeName': 'Akan'
    },
    'sq': {
      'name': 'Albanian',
      'nativeName': 'Shqip'
    },
    'am': {
      'name': 'Amharic',
      'nativeName': 'አማርኛ'
    },
    'ar': {
      'name': 'Arabic',
      'nativeName': 'العربية'
    },
    'an': {
      'name': 'Aragonese',
      'nativeName': 'Aragonés'
    },
    'hy': {
      'name': 'Armenian',
      'nativeName': 'Հայերեն'
    },
    'as': {
      'name': 'Assamese',
      'nativeName': 'অসমীয়া'
    },
    'av': {
      'name': 'Avaric',
      'nativeName': 'авар мацӀ, магӀарул мацӀ'
    },
    'ae': {
      'name': 'Avestan',
      'nativeName': 'avesta'
    },
    'ay': {
      'name': 'Aymara',
      'nativeName': 'aymar aru'
    },
    'az': {
      'name': 'Azerbaijani',
      'nativeName': 'azərbaycan dili'
    },
    'bm': {
      'name': 'Bambara',
      'nativeName': 'bamanankan'
    },
    'ba': {
      'name': 'Bashkir',
      'nativeName': 'башҡорт теле'
    },
    'eu': {
      'name': 'Basque',
      'nativeName': 'euskara, euskera'
    },
    'be': {
      'name': 'Belarusian',
      'nativeName': 'Беларуская'
    },
    'bn': {
      'name': 'Bengali',
      'nativeName': 'বাংলা'
    },
    'bh': {
      'name': 'Bihari',
      'nativeName': 'भोजपुरी'
    },
    'bi': {
      'name': 'Bislama',
      'nativeName': 'Bislama'
    },
    'bs': {
      'name': 'Bosnian',
      'nativeName': 'bosanski jezik'
    },
    'br': {
      'name': 'Breton',
      'nativeName': 'brezhoneg'
    },
    'bg': {
      'name': 'Bulgarian',
      'nativeName': 'български език'
    },
    'my': {
      'name': 'Burmese',
      'nativeName': 'ဗမာစာ'
    },
    'ca': {
      'name': 'Catalan; Valencian',
      'nativeName': 'Català'
    },
    'ch': {
      'name': 'Chamorro',
      'nativeName': 'Chamoru'
    },
    'ce': {
      'name': 'Chechen',
      'nativeName': 'нохчийн мотт'
    },
    'ny': {
      'name': 'Chichewa; Chewa; Nyanja',
      'nativeName': 'chiCheŵa, chinyanja'
    },
    'zh': {
      'name': 'Chinese',
      'nativeName': '中文 (Zhōngwén), 汉语, 漢語'
    },
    'cv': {
      'name': 'Chuvash',
      'nativeName': 'чӑваш чӗлхи'
    },
    'kw': {
      'name': 'Cornish',
      'nativeName': 'Kernewek'
    },
    'co': {
      'name': 'Corsican',
      'nativeName': 'corsu, lingua corsa'
    },
    'cr': {
      'name': 'Cree',
      'nativeName': 'ᓀᐦᐃᔭᐍᐏᐣ'
    },
    'hr': {
      'name': 'Croatian',
      'nativeName': 'hrvatski'
    },
    'cs': {
      'name': 'Czech',
      'nativeName': 'česky, čeština'
    },
    'da': {
      'name': 'Danish',
      'nativeName': 'dansk'
    },
    'dv': {
      'name': 'Divehi; Dhivehi; Maldivian;',
      'nativeName': 'ދިވެހި'
    },
    'nl': {
      'name': 'Dutch',
      'nativeName': 'Nederlands, Vlaams'
    },
    'en': {
      'name': 'English',
      'nativeName': 'English'
    },
    'eo': {
      'name': 'Esperanto',
      'nativeName': 'Esperanto'
    },
    'et': {
      'name': 'Estonian',
      'nativeName': 'eesti, eesti keel'
    },
    'ee': {
      'name': 'Ewe',
      'nativeName': 'Eʋegbe'
    },
    'fo': {
      'name': 'Faroese',
      'nativeName': 'føroyskt'
    },
    'fj': {
      'name': 'Fijian',
      'nativeName': 'vosa Vakaviti'
    },
    'fi': {
      'name': 'Finnish',
      'nativeName': 'suomi, suomen kieli'
    },
    'fr': {
      'name': 'French',
      'nativeName': 'français, langue française'
    },
    'ff': {
      'name': 'Fula; Fulah; Pulaar; Pular',
      'nativeName': 'Fulfulde, Pulaar, Pular'
    },
    'gl': {
      'name': 'Galician',
      'nativeName': 'Galego'
    },
    'ka': {
      'name': 'Georgian',
      'nativeName': 'ქართული'
    },
    'de': {
      'name': 'German',
      'nativeName': 'Deutsch'
    },
    'el': {
      'name': 'Greek, Modern',
      'nativeName': 'Ελληνικά'
    },
    'gn': {
      'name': 'Guaraní',
      'nativeName': 'Avañeẽ'
    },
    'gu': {
      'name': 'Gujarati',
      'nativeName': 'ગુજરાતી'
    },
    'ht': {
      'name': 'Haitian; Haitian Creole',
      'nativeName': 'Kreyòl ayisyen'
    },
    'ha': {
      'name': 'Hausa',
      'nativeName': 'Hausa, هَوُسَ'
    },
    'he': {
      'name': 'Hebrew (modern)',
      'nativeName': 'עברית'
    },
    'hz': {
      'name': 'Herero',
      'nativeName': 'Otjiherero'
    },
    'hi': {
      'name': 'Hindi',
      'nativeName': 'हिन्दी, हिंदी'
    },
    'ho': {
      'name': 'Hiri Motu',
      'nativeName': 'Hiri Motu'
    },
    'hu': {
      'name': 'Hungarian',
      'nativeName': 'Magyar'
    },
    'ia': {
      'name': 'Interlingua',
      'nativeName': 'Interlingua'
    },
    'id': {
      'name': 'Indonesian',
      'nativeName': 'Bahasa Indonesia'
    },
    'ie': {
      'name': 'Interlingue',
      'nativeName': 'Originally called Occidental; then Interlingue after WWII'
    },
    'ga': {
      'name': 'Irish',
      'nativeName': 'Gaeilge'
    },
    'ig': {
      'name': 'Igbo',
      'nativeName': 'Asụsụ Igbo'
    },
    'ik': {
      'name': 'Inupiaq',
      'nativeName': 'Iñupiaq, Iñupiatun'
    },
    'io': {
      'name': 'Ido',
      'nativeName': 'Ido'
    },
    'is': {
      'name': 'Icelandic',
      'nativeName': 'Íslenska'
    },
    'it': {
      'name': 'Italian',
      'nativeName': 'Italiano'
    },
    'iu': {
      'name': 'Inuktitut',
      'nativeName': 'ᐃᓄᒃᑎᑐᑦ'
    },
    'ja': {
      'name': 'Japanese',
      'nativeName': '日本語 (にほんご／にっぽんご)'
    },
    'jv': {
      'name': 'Javanese',
      'nativeName': 'basa Jawa'
    },
    'kl': {
      'name': 'Kalaallisut, Greenlandic',
      'nativeName': 'kalaallisut, kalaallit oqaasii'
    },
    'kn': {
      'name': 'Kannada',
      'nativeName': 'ಕನ್ನಡ'
    },
    'kr': {
      'name': 'Kanuri',
      'nativeName': 'Kanuri'
    },
    'ks': {
      'name': 'Kashmiri',
      'nativeName': 'कश्मीरी, كشميري‎'
    },
    'kk': {
      'name': 'Kazakh',
      'nativeName': 'Қазақ тілі'
    },
    'km': {
      'name': 'Khmer',
      'nativeName': 'ភាសាខ្មែរ'
    },
    'ki': {
      'name': 'Kikuyu, Gikuyu',
      'nativeName': 'Gĩkũyũ'
    },
    'rw': {
      'name': 'Kinyarwanda',
      'nativeName': 'Ikinyarwanda'
    },
    'ky': {
      'name': 'Kirghiz, Kyrgyz',
      'nativeName': 'кыргыз тили'
    },
    'kv': {
      'name': 'Komi',
      'nativeName': 'коми кыв'
    },
    'kg': {
      'name': 'Kongo',
      'nativeName': 'KiKongo'
    },
    'ko': {
      'name': 'Korean',
      'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)'
    },
    'ku': {
      'name': 'Kurdish',
      'nativeName': 'Kurdî, كوردی‎'
    },
    'kj': {
      'name': 'Kwanyama, Kuanyama',
      'nativeName': 'Kuanyama'
    },
    'la': {
      'name': 'Latin',
      'nativeName': 'latine, lingua latina'
    },
    'lb': {
      'name': 'Luxembourgish, Letzeburgesch',
      'nativeName': 'Lëtzebuergesch'
    },
    'lg': {
      'name': 'Luganda',
      'nativeName': 'Luganda'
    },
    'li': {
      'name': 'Limburgish, Limburgan, Limburger',
      'nativeName': 'Limburgs'
    },
    'ln': {
      'name': 'Lingala',
      'nativeName': 'Lingála'
    },
    'lo': {
      'name': 'Lao',
      'nativeName': 'ພາສາລາວ'
    },
    'lt': {
      'name': 'Lithuanian',
      'nativeName': 'lietuvių kalba'
    },
    'lu': {
      'name': 'Luba-Katanga',
      'nativeName': ''
    },
    'lv': {
      'name': 'Latvian',
      'nativeName': 'latviešu valoda'
    },
    'gv': {
      'name': 'Manx',
      'nativeName': 'Gaelg, Gailck'
    },
    'mk': {
      'name': 'Macedonian',
      'nativeName': 'македонски јазик'
    },
    'mg': {
      'name': 'Malagasy',
      'nativeName': 'Malagasy fiteny'
    },
    'ms': {
      'name': 'Malay',
      'nativeName': 'bahasa Melayu, بهاس ملايو‎'
    },
    'ml': {
      'name': 'Malayalam',
      'nativeName': 'മലയാളം'
    },
    'mt': {
      'name': 'Maltese',
      'nativeName': 'Malti'
    },
    'mi': {
      'name': 'Māori',
      'nativeName': 'te reo Māori'
    },
    'mr': {
      'name': 'Marathi (Marāṭhī)',
      'nativeName': 'मराठी'
    },
    'mh': {
      'name': 'Marshallese',
      'nativeName': 'Kajin M̧ajeļ'
    },
    'mn': {
      'name': 'Mongolian',
      'nativeName': 'монгол'
    },
    'na': {
      'name': 'Nauru',
      'nativeName': 'Ekakairũ Naoero'
    },
    'nv': {
      'name': 'Navajo, Navaho',
      'nativeName': 'Diné bizaad, Dinékʼehǰí'
    },
    'nb': {
      'name': 'Norwegian Bokmål',
      'nativeName': 'Norsk bokmål'
    },
    'nd': {
      'name': 'North Ndebele',
      'nativeName': 'isiNdebele'
    },
    'ne': {
      'name': 'Nepali',
      'nativeName': 'नेपाली'
    },
    'ng': {
      'name': 'Ndonga',
      'nativeName': 'Owambo'
    },
    'nn': {
      'name': 'Norwegian Nynorsk',
      'nativeName': 'Norsk nynorsk'
    },
    'no': {
      'name': 'Norwegian',
      'nativeName': 'Norsk'
    },
    'ii': {
      'name': 'Nuosu',
      'nativeName': 'ꆈꌠ꒿ Nuosuhxop'
    },
    'nr': {
      'name': 'South Ndebele',
      'nativeName': 'isiNdebele'
    },
    'oc': {
      'name': 'Occitan',
      'nativeName': 'Occitan'
    },
    'oj': {
      'name': 'Ojibwe, Ojibwa',
      'nativeName': 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
    },
    'cu': {
      'name': 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
      'nativeName': 'ѩзыкъ словѣньскъ'
    },
    'om': {
      'name': 'Oromo',
      'nativeName': 'Afaan Oromoo'
    },
    'or': {
      'name': 'Oriya',
      'nativeName': 'ଓଡ଼ିଆ'
    },
    'os': {
      'name': 'Ossetian, Ossetic',
      'nativeName': 'ирон æвзаг'
    },
    'pa': {
      'name': 'Panjabi, Punjabi',
      'nativeName': 'ਪੰਜਾਬੀ, پنجابی‎'
    },
    'pi': {
      'name': 'Pāli',
      'nativeName': 'पाऴि'
    },
    'fa': {
      'name': 'Persian',
      'nativeName': 'فارسی'
    },
    'pl': {
      'name': 'Polish',
      'nativeName': 'polski'
    },
    'ps': {
      'name': 'Pashto, Pushto',
      'nativeName': 'پښتو'
    },
    'pt': {
      'name': 'Portuguese',
      'nativeName': 'Português'
    },
    'qu': {
      'name': 'Quechua',
      'nativeName': 'Runa Simi, Kichwa'
    },
    'rm': {
      'name': 'Romansh',
      'nativeName': 'rumantsch grischun'
    },
    'rn': {
      'name': 'Kirundi',
      'nativeName': 'kiRundi'
    },
    'ro': {
      'name': 'Romanian, Moldavian, Moldovan',
      'nativeName': 'română'
    },
    'ru': {
      'name': 'Russian',
      'nativeName': 'русский язык'
    },
    'sa': {
      'name': 'Sanskrit (Saṁskṛta)',
      'nativeName': 'संस्कृतम्'
    },
    'sc': {
      'name': 'Sardinian',
      'nativeName': 'sardu'
    },
    'sd': {
      'name': 'Sindhi',
      'nativeName': 'सिन्धी, سنڌي، سندھی‎'
    },
    'se': {
      'name': 'Northern Sami',
      'nativeName': 'Davvisámegiella'
    },
    'sm': {
      'name': 'Samoan',
      'nativeName': 'gagana faa Samoa'
    },
    'sg': {
      'name': 'Sango',
      'nativeName': 'yângâ tî sängö'
    },
    'sr': {
      'name': 'Serbian',
      'nativeName': 'српски језик'
    },
    'gd': {
      'name': 'Scottish Gaelic; Gaelic',
      'nativeName': 'Gàidhlig'
    },
    'sn': {
      'name': 'Shona',
      'nativeName': 'chiShona'
    },
    'si': {
      'name': 'Sinhala, Sinhalese',
      'nativeName': 'සිංහල'
    },
    'sk': {
      'name': 'Slovak',
      'nativeName': 'slovenčina'
    },
    'sl': {
      'name': 'Slovene',
      'nativeName': 'slovenščina'
    },
    'so': {
      'name': 'Somali',
      'nativeName': 'Soomaaliga, af Soomaali'
    },
    'st': {
      'name': 'Southern Sotho',
      'nativeName': 'Sesotho'
    },
    'es': {
      'name': 'Spanish; Castilian',
      'nativeName': 'español, castellano'
    },
    'su': {
      'name': 'Sundanese',
      'nativeName': 'Basa Sunda'
    },
    'sw': {
      'name': 'Swahili',
      'nativeName': 'Kiswahili'
    },
    'ss': {
      'name': 'Swati',
      'nativeName': 'SiSwati'
    },
    'sv': {
      'name': 'Swedish',
      'nativeName': 'svenska'
    },
    'ta': {
      'name': 'Tamil',
      'nativeName': 'தமிழ்'
    },
    'te': {
      'name': 'Telugu',
      'nativeName': 'తెలుగు'
    },
    'tg': {
      'name': 'Tajik',
      'nativeName': 'тоҷикӣ, toğikī, تاجیکی‎'
    },
    'th': {
      'name': 'Thai',
      'nativeName': 'ไทย'
    },
    'ti': {
      'name': 'Tigrinya',
      'nativeName': 'ትግርኛ'
    },
    'bo': {
      'name': 'Tibetan Standard, Tibetan, Central',
      'nativeName': 'བོད་ཡིག'
    },
    'tk': {
      'name': 'Turkmen',
      'nativeName': 'Türkmen, Түркмен'
    },
    'tl': {
      'name': 'Tagalog',
      'nativeName': 'Wikang Tagalog'
    },
    'tn': {
      'name': 'Tswana',
      'nativeName': 'Setswana'
    },
    'to': {
      'name': 'Tonga (Tonga Islands)',
      'nativeName': 'faka Tonga'
    },
    'tr': {
      'name': 'Turkish',
      'nativeName': 'Türkçe'
    },
    'ts': {
      'name': 'Tsonga',
      'nativeName': 'Xitsonga'
    },
    'tt': {
      'name': 'Tatar',
      'nativeName': 'татарча, tatarça, تاتارچا‎'
    },
    'tw': {
      'name': 'Twi',
      'nativeName': 'Twi'
    },
    'ty': {
      'name': 'Tahitian',
      'nativeName': 'Reo Tahiti'
    },
    'ug': {
      'name': 'Uighur, Uyghur',
      'nativeName': 'Uyƣurqə, ئۇيغۇرچە‎'
    },
    'uk': {
      'name': 'Ukrainian',
      'nativeName': 'українська'
    },
    'ur': {
      'name': 'Urdu',
      'nativeName': 'اردو'
    },
    'uz': {
      'name': 'Uzbek',
      'nativeName': 'zbek, Ўзбек, أۇزبېك‎'
    },
    've': {
      'name': 'Venda',
      'nativeName': 'Tshivenḓa'
    },
    'vi': {
      'name': 'Vietnamese',
      'nativeName': 'Tiếng Việt'
    },
    'vo': {
      'name': 'Volapük',
      'nativeName': 'Volapük'
    },
    'wa': {
      'name': 'Walloon',
      'nativeName': 'Walon'
    },
    'cy': {
      'name': 'Welsh',
      'nativeName': 'Cymraeg'
    },
    'wo': {
      'name': 'Wolof',
      'nativeName': 'Wollof'
    },
    'fy': {
      'name': 'Western Frisian',
      'nativeName': 'Frysk'
    },
    'xh': {
      'name': 'Xhosa',
      'nativeName': 'isiXhosa'
    },
    'yi': {
      'name': 'Yiddish',
      'nativeName': 'ייִדיש'
    },
    'yo': {
      'name': 'Yoruba',
      'nativeName': 'Yorùbá'
    },
    'za': {
      'name': 'Zhuang, Chuang',
      'nativeName': 'Saɯ cueŋƅ, Saw cuengh'
    }
  },
  menuNewValueDefault: {
    ID: 'new',
    isNew: true,
    Name: {
      es: `Menu`
    },
    Common: 0
  },
  totem: {
    messages: {
      height: 50
    },
    meteo: {
      // height: '228'
      height: 178
    },
    textoMenuActivo: {
      height: 140
    },
    sidebar: {
      width: 228
    },
    accessibility: {
      height: 128
    },
    mainMenu: {
      height: 178
    }
  }
}

export default constants
